import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { SpinnerOverlay } from "@components";
import { InvoiceProvider } from "@bonliva-crm/shared";
import { FormStore } from "@modules/formx";
import { moment } from "@bonliva-crm/common";
import { Form, Text, Date as DateInput, FormxDebugger } from "@common/formx";
import { useObserver } from "mobx-react";

export type FormState = {
  provider: InvoiceProvider | null;
  description: string | null;
  date: string | Date;
};

type Props = {
  form: FormStore<FormState>;
  loading: boolean;
  open: boolean;
  onClose: () => void;
  result?: string | null;
};

export default function VoucherFortnoxForm(props: Props) {
  return useObserver(() => (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>{locale.FortnoxCreateVouchersForm}</DialogTitle>

      <DialogContent>
        <SpinnerOverlay show={props.loading} />
        <FormxDebugger store={props.form as any} />
        {props.result ? (
          <Typography style={{ whiteSpace: "pre-line" }}>
            <strong>{props.result}</strong>
          </Typography>
        ) : (
          <Form<FormState> store={props.form} allowUpdates>
            <div>
              <DateInput
                utc
                key={"date"}
                DatePickerProps={{
                  startDate: moment().toDate(),
                  shouldCloseOnSelect: true
                }}
                name="date"
                // transformValue={v => moment(v).format("YYYY-MM-DD")}
                label={locale.PostingDate}
              />
            </div>
            <div>
              <Text name={"description"} label={locale.Description} />
            </div>
          </Form>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            props.onClose();
          }}
          color="primary"
          // variant="contained"
        >
          {locale.Close1}
        </Button>
        {!props.result && (
          <Button
            type={"submit"}
            disabled={!props.form.canSubmit || props.loading}
            color="primary"
            variant="contained"
            onClick={props.form.submit}
          >
            {locale.Send}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  ));
}
